module.exports = __webpack_public_path__ + "img/a_1.403d6995.png";